import login from './login';
import logout from './logout';
import register from './register';

export default {
  login,
  logout,
  register,
};



// WEBPACK FOOTER //
// ./src/app/services/auth/index.js